/** 子应用向主应用发送的请求类型 */
export var MicroAppActionType;
(function (MicroAppActionType) {
  /** 获取预设风格模板列表 */
  MicroAppActionType['GET_TEMPLATE_LIST'] = 'GET_TEMPLATE_LIST';
  /** 获取数字人列表 */
  MicroAppActionType['GET_DIGITAL_HUMAN_LIST'] = 'GET_DIGITAL_HUMAN_LIST';
  /** 获取配音列表 */
  MicroAppActionType['GET_VOICE_LIST'] = 'GET_VOICE_LIST';
  /** 获取个人素材标签列表 */
  MicroAppActionType['GET_MATERIAL_TAG_LIST'] = 'GET_MATERIAL_TAG_LIST';
  /** 保存风格 */
  MicroAppActionType['SAVE_STYLE'] = 'SAVE_STYLE';
  /** 关闭弹窗 */
  MicroAppActionType['CLOSE'] = 'CLOSE';
  /** 获取公共数字人列表 */
  MicroAppActionType['GET_PUBLIC_DIGITAL_HUMAN_LIST'] =
    'GET_PUBLIC_DIGITAL_HUMAN_LIST';
  /** 获取公共配音列表 */
  MicroAppActionType['GET_PUBLIC_VOICE_LIST'] = 'GET_PUBLIC_VOICE_LIST';
  /** 获取公共数字人分类列表 */
  MicroAppActionType['GET_PUBLIC_DIGITAL_HUMAN_CATEGORY'] =
    'GET_PUBLIC_DIGITAL_HUMAN_CATEGORY';
  /** 获取公共配音分类列表 */
  MicroAppActionType['GET_PUBLIC_VOICE_CATEGORY'] = 'GET_PUBLIC_VOICE_CATEGORY';
})(MicroAppActionType || (MicroAppActionType = {}));
export const HOST_MAP = {
  dev: 'http://localhost:17000/',
  test: 'https://vidflow-style-editor.test.bhbapp.cn',
  gray: 'https://vidflow-style-editor.bj.gray.bhbapp.cn',
  prod: 'https://vidflow-style-editor.bhbapp.cn',
};
/** 素材标记 */
export var MATERIAL_TYPE;
(function (MATERIAL_TYPE) {
  /** 个人 */
  MATERIAL_TYPE['PERSONAL'] = 'personal';
  /** 场景 */
  MATERIAL_TYPE['SCENE'] = 'scene';
  /** 公共 */
  MATERIAL_TYPE['COMMON'] = 'common';
  /** AI生图 */
  MATERIAL_TYPE['AI'] = 'ai';
  /** 不使用素材 */
  MATERIAL_TYPE['NONE'] = 'nonuse';
})(MATERIAL_TYPE || (MATERIAL_TYPE = {}));
/** 视频风格类型 */
export var VIDEO_STYLE_TYPE;
(function (VIDEO_STYLE_TYPE) {
  /** 数字人口播 */
  VIDEO_STYLE_TYPE['VIRTUAL_MAN'] = 'virtualman';
  /** 真人口播 */
  VIDEO_STYLE_TYPE['REAL_MAN'] = 'realMan';
  /** 新闻混剪体 */
  VIDEO_STYLE_TYPE['NEWS_MIX_CUTTING'] = 'newsMixCutting';
  /** 口播混剪体 */
  VIDEO_STYLE_TYPE['ORAL_MIX_CUTTING'] = 'oralMixCutting';
  /** 文本展示体 */
  VIDEO_STYLE_TYPE['WRITING_SHOW'] = 'writingShow';
  /** 图片封面 */
  VIDEO_STYLE_TYPE['IMAGE_TOPIC'] = 'imageTopic';
})(VIDEO_STYLE_TYPE || (VIDEO_STYLE_TYPE = {}));
